import { Component, Input } from '@angular/core';

import { GenericFilterParameter } from '../../../models/generic-comunication-cmp';
import { GenericTableField } from '../../../models/generic-table-field';

import { DataService } from '../../../services/data.service';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'app-app-component-generic',
  templateUrl: './app-component-generic.component.html',
  styleUrls: ['./app-component-generic.component.css']
})
export class AppComponentGenericComponent {
    @Input() writePermission: any;
    administrator: boolean = false;
    permissions: any = null;

    // Detail
    masterState: string;
    detailState: string;

    // Inter-Comunication parameter
    parametriString: string = "{}";
    parametri: GenericFilterParameter = null;

    // Table
    headerFields: GenericTableField[];
    footerFields: GenericTableField[];

    constructor(protected dataService: DataService, private keyComponent: string){
        //console.log("parametri pre", this.parametri);
        this.parametri = new GenericFilterParameter();
        //console.log("parametri post", this.parametri);
        this.resetAnimationState();
    }

    checkPermission(key: any, permission: any, filter = 'global'){
        return this.dataService.checkPermission(key, permission, filter);
    }

    updateParametri(){
        //console.log('CMP|COMPONENT-GENERIC - UPDATEPARAMETRI', this.parametri);
        this.parametriString = this.parametri.generateParametriToString();
        //console.log('CMP|COMPONENT-GENERIC - UPDATEPARAMETRI STRING', this.parametriString);
    }

    changeAnimationState(){
        if(this.masterState == "background"){
            this.masterState = "foreground";
        }else{
            this.masterState = "background";
        }

        if(this.detailState == "background"){
            this.detailState = "foreground";
        }else{
            this.detailState = "background";
        }
    }

    resetAnimationState(){
        this.masterState = "foreground";
        this.detailState = "background";
    }

    animationDetailStarted($event) {
        //console.log('animation Detail Start', $event);
    }

    animationDetailDone($event) {
        //console.log('animation Detail End', $event);
    }

    animationMasterStarted($event) {
        //console.log('animation Master Start', $event);
    }

    animationMasterDone($event) {
        //console.log('animation Master End', $event);
    }

}
